import React, { useEffect, useState } from "react";
import {
  DonationBackground,
  DonationContainer,
  DonationCloseIcon,
  DonationHeader,
  DonationTitle,
  AmountOptions,
  AmountInput,
  BadgeOptions,
  Badge,
  BadgeLabel,
  DonateButton,
} from "./DonationAmountModal.styles";
import bronzeMedal from "assets/images/medal-third-place.png";
import silverMedal from "assets/images/medal-second-place.png";
import goldMedal from "assets/images/medal-first-place.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateShowDonationAmountScreen } from "store/ui/donationAmountScreen/donationAmountScreen.slice";
import { useAppSelector } from "store/hooks";
import { useSelector } from "react-redux";
import { RootState } from "store/types";

const badges = [
  { label: "$25-45", value: "bronze", src: bronzeMedal, range: [25, 45] },
  { label: "$50-100", value: "silver", src: silverMedal, range: [50, 100] },
  { label: "$100", value: "gold", src: goldMedal, range: [100, 100] },
];

function DonationAmountModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [amount, setAmount] = useState<number | undefined>(undefined);
  const [selectedBadge, setSelectedBadge] = useState<string | null>(null);
  const showDonationAmount = useAppSelector(
    (state) => state.showDonationAmount
  );
  const auth = useSelector((state: RootState) => state.auth);

  const handleAmountChange = (value: number) => {
    setAmount(value);
    const matchedBadge = badges.find(b => (b.range[0] < 100 && value >= b.range[0] && value < b.range[1]) || (b.range[0] >= 100 && value >= b.range[0]));
    setSelectedBadge(matchedBadge?.value ?? null);
  };

  const handleBadgeClick = (badgeValue: string) => {
    const badge = badges.find(b => b.value === badgeValue);
    setSelectedBadge(badgeValue);
    if (badge) setAmount(badge.range[0]);
  };

  useEffect(() => {
    console.log(showDonationAmount)
  })

  return (
    <>
      <DonationBackground onClick={() => dispatch(updateShowDonationAmountScreen({show: false}))} />
      <DonationContainer>
        <DonationCloseIcon className="fa-solid fa-xmark" onClick={() => dispatch(updateShowDonationAmountScreen({show: false}))} />
        <DonationHeader>
          <DonationTitle>How much do you want to donate?</DonationTitle>

          <AmountOptions>
            {[25, 50, 100].map(val => (
              <label key={val}>
                <input
                  type="radio"
                  name="amount"
                  checked={amount === val}
                  onChange={() => handleAmountChange(val)}
                />
                ${val}
              </label>
            ))}
            <div>
              <AmountInput
                type="number"
                value={amount ?? ""}
                onChange={(e) => handleAmountChange(Number(e.target.value))}
              />
              <p>Customize</p>
            </div>
          </AmountOptions>

          <p>Or select a badge</p>
          <BadgeOptions>
            {badges.map(badge => (
              <Badge
                key={badge.value}
                $active={selectedBadge === badge.value}
                onClick={() => handleBadgeClick(badge.value)}
              >
                {badge.src ? (<img src={badge.src} />) : (<div className={`medal ${badge.value}`} />)}
                <BadgeLabel>{badge.label}</BadgeLabel>
              </Badge>
            ))}
          </BadgeOptions>
        </DonationHeader>

        <DonateButton onClick={() => amount && navigate(`/donate?userId=${auth.userId}&campaignShort=${showDonationAmount.campaignShort}&activityId=${showDonationAmount.activityId}&amount=${amount*100}`)}>Donate Now</DonateButton>
      </DonationContainer>
    </>
  );
}

export default DonationAmountModal;
